import React from 'react'
import { Box, Container } from '@mui/material';

import { withStyles } from '@mui/styles'

import { ConsultComponent } from '../../../features/consult'
import { consultStyles } from './consult.styles'
import { useCombos } from '../../../features/combos'

export const ConsultPage = withStyles(consultStyles)(({ classes }) => {
  useCombos(['tipo_mercado','uso_punto_suministro', 'call_center_sub_origins','origen_solicitud'])

  return (
    <div className={classes.root}>
      <Container className={classes.container} maxWidth="lg">
        <Box bgcolor="common.white" borderRadius="4px" p={[2, 5]} mt={[1, 3]}>
          <ConsultComponent />
        </Box>
      </Container>
    </div>
  );
})
